import { useQueryClient } from 'react-query';
import { useLogger } from '@lumahealthhq/ui-utils';
import { useAxiosClient } from '../hooks';
import { createQueryKey } from '../utils';
import useMutation from './useMutation';
export default function useUpdateOne(variant, basePath, options) {
  const axiosClient = useAxiosClient();
  const queryClient = useQueryClient();
  const logger = useLogger();
  async function mutationFn(data) {
    const url = variant.replace('{basePath}', basePath).replace('{id}', data._id);
    const response = await axiosClient.put(url, data);

    // Invalidate queries that depend on this `id`
    queryClient.invalidateQueries(data._id).catch(logger.warn);
    return response.data;
  }
  const mutationKey = createQueryKey(basePath, variant);
  const mutation = useMutation(mutationKey, mutationFn, options);
  return mutation;
}